module.exports = __webpack_public_path__ + "static/media/fly0057.c250f2ee.webp";